<template>
  <Head>
    <title>
      {{ title ? title + " | " : "" }}{{ $page.props.config.app.name }}
    </title>
    <meta name="robots" content="index,follow" />
    <link rel="canonical" head-key="canonical" :href="canonicalUrl" />
    <meta
      name="description"
      :content="(metaDescription ? metaDescription : 'Auf uns können Sie sich verlassen, wenn es um Ihren Skiurlaub in der Gruppe mit Familie, den Skispaß mit Freunden oder den Winterurlaub zu zweit in den einmalig schönen Skigebieten Österreichs geht. Wir haben für jeden Winterurlauber das passende Angebot.')"
    />
    <meta
      name="keywords"
      :content="(metaKeywords ? metaKeywords : 'Gruppenreisen, Skireisen, Gruppe, Skiurlaub, Busreisen')"
    />

    <slot name="head"></slot>
  </Head>
  <div id="wrapper">
    <header id="header" class="fixed-top header-minimal">
      <nav
        class="navbar navbar-expand-lg navbar-light navbar-minimal"
        id="navbar-booking"
      >
        <div class="container d-block">
            <div class="row justify-content-between">
              <div class="col-12 col-md-3 header-minimal-logo">
                <div id="header-logo-minimal" class="d-block position-relative">
                  <Link :href="$route('home')">
                    <img
                      :src="$page.props.page.assets.logo"
                      alt="SCOL Skireisen Logo"
                    />
                  </Link>
                </div>
              </div>
              <div class="col-12 col-md-6 nav-item text-center header-minimal-question">
                Fragen? Wir sind für dich da
                <a href="tel:++49443596000">04435 96000</a>
              </div>
              <div class="d-none d-md-block col-md-3 header-minimal-start nav-item text-end">
                <Link
                  :href="$route('search-results')"
                  class="text-decoration-none text-body"
                >
                  <i class="fas fa-arrow-left"></i> Zurück zum Start
                </Link>
              </div>
            </div>
          </div>
      </nav>
    </header>

    <main id="main" class="bg-light booking-background" :class="{ 'no-banner': !banner.src }">
      <section
        v-if="banner.src"
        class="banner-top"
        :class="{ full: banner.type == 'full' }"
        :style="h1Style"
      >
        <div class="scol-caption" v-if="h1">
          <h1>{{ h1 }}</h1>
        </div>
      </section>
      <slot />
    </main>

    <Footer />
  </div>
  <login-modal />
</template>


<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import LoginModal from "../../Components/Auth/LoginModal";
import Footer from "../../Components/Scol/Footer";

export default {
  components: {
    Head,
    Link,
    LoginModal,
    Footer,
  },
  props: {
    title: String,
    metaKeywords: String,
    metaDescription: String,
    canonical: String,
    banner: {
      type: Object,
      default: {
        src: null,
        type: "stretch",
      },
    },
    h1: String,
  },
  computed: {
    canonicalUrl() {
      return this.canonical || this.$page.props.page.canonical;
    },
    h1Style() {
      if (!this.banner.src) {
        return;
      }

      let style = "background-image: url('" + this.banner.src + "')";

      if (this.banner.position) {
        style += ";background-position: " + this.banner.position;
      }

      return style;
    },
  },
  mounted(){
      if (getCookieValue("googleanalytics") == true) {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");

        script.text =
            "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
            "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
            "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
            "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
            "})(window,document,'script','dataLayer','GTM-PSGCN7PH');";

        head.insertBefore(script, head.firstChild);

        var body = document.getElementsByTagName("body")[0];
        var noscript = document.createElement("noscript");

        var iframe = document.createElement("iframe");
        iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PSGCN7PH";
        iframe.height = "0";
        iframe.width = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";

        noscript.appendChild(iframe);

        body.insertBefore(noscript, body.firstChild);
    }

    if (getCookieValue("googleads") == true) {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");

        script.text = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        `;

        head.insertBefore(script, head.firstChild);
    }


    if (getCookieValue("facebookpixel") == true) {
        var scriptTag = document.createElement('script');
        scriptTag.innerHTML = `
            !function(f,b,e,v,n,t,s) {
                if(f.fbq)return;
                n=f.fbq=function(){
                    n.callMethod ?
                    n.callMethod.apply(n,arguments) : n.queue.push(arguments)
                };
                if(!f._fbq)f._fbq=n;
                n.push=n;
                n.loaded=!0;
                n.version='2.0';
                n.queue=[];
                t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)
            }(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '911865391057583');
            fbq('track', 'PageView');
        `;
        document.head.appendChild(scriptTag);

        var noscriptTag = document.createElement('noscript');
        var imgTag = document.createElement('img');
        imgTag.height = 1;
        imgTag.width = 1;
        imgTag.style.display = 'none';
        imgTag.src = "https://www.facebook.com/tr?id=911865391057583&ev=PageView&noscript=1";
        noscriptTag.appendChild(imgTag);
        document.head.appendChild(noscriptTag);
    }
}
};
</script>
